import { Typography } from '@mui/material';
import React from 'react';

/* eslint-disable @typescript-eslint/indent */
export class ElasticRegexInfo extends React.Component {
    public render(): React.ReactNode {
        return (
            <React.Fragment>
                <Typography variant='h6'>Notes On ElasticSearch RegExes</Typography>
                <ul>
                    <li>
                        Neg Look Ahead is supported (ex. <strong>(?!PRIME)</strong>), no look behinds
                    </li>
                    <li>
                        Matching EMPTY fields can be achieved by using the following pattern: <strong>.{'{0}'}</strong>
                        <br />
                        This was not verified in seam module, but can be safely used in filters.
                    </li>
                    <li>
                        ES does not support character classes codes like <strong>\d, \w</strong>; use ranges
                        <ul>
                            <li>
                                <strong>\d</strong> == <strong>[0-9]</strong>
                            </li>
                            <li>
                                <strong>\D</strong> == <strong>[^0-9]</strong>
                            </li>
                            <li>
                                <strong>\w</strong> == <strong>[A-Z_0-9]</strong>
                            </li>
                            <li>
                                <strong>\W</strong> == <strong>[^A-Z_0-9]</strong>
                            </li>
                        </ul>
                    </li>
                    <li>
                        In ES all patterns match against entire string.
                        <ul>
                            <li>
                                Thus <strong>^</strong> (beginning of line) and <strong>$</strong> (end of line) are not
                                supported within the pattern field (they are implied by default)
                            </li>
                            <li>
                                The <strong>^</strong> and <strong>$</strong> will be appended to start and end of
                                pattern when pattern is exported to pre-prod
                            </li>
                        </ul>
                    </li>
                </ul>
            </React.Fragment>
        );
    }
}
